import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Layout } from "@/components/pt/Layout";
import { ScrollToTop } from "@/components/pt/ScrollToTop";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Commerce from "@/pages/Commerce";
import Banks from "@/pages/Banks";
import People from "@/pages/People";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ComingSoon from "@/pages/ComingSoon";

function App() {
    return (
        <div className="App">
            <LanguageProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Layout>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/servicios" element={<Services />} />
                            <Route path="/comercios" element={<Commerce />} />
                            <Route path="/bancos" element={<Banks />} />
                            <Route path="/personas" element={<People />} />
                            <Route path="/nosotros" element={<About />} />
                            <Route path="/contacto" element={<Contact />} />
                            <Route
                                path="*"
                                element={<ComingSoon pageKey="home" />}
                            />
                        </Routes>
                    </Layout>
                </BrowserRouter>
            </LanguageProvider>
        </div>
    );
}

export default App;
